<template>
  <div class="frame pb-0">
    <div class="container">
      <div class="row no-gutters">
        <div class="col">
          <calculation-request-form />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalculationRequestForm from "./CalculationRequestForm";

export default {
  name: "CalculationRequest",
  components: {
    CalculationRequestForm
  }
};
</script>

<style></style>
